import BaseComponent from './BaseComponent';
import { throttle }  from 'lodash';

class TextArea extends BaseComponent {
  constructor(componentName, autoInit){
    super(componentName);  // Params passed to BaseComponent
  }

  // Init function will run after BaseComponent Constructor
  init(component) {
    this.addCustomEvents(component); 
  }


  addCustomEvents(component) {
    const textArea = component.element;
    const value = 400;
    // Initial load
    this.autosize(textArea);
    
    textArea.addEventListener('change', _.throttle(() => {
      this.autosize(textArea);
    }, 400), false);
    
    textArea.addEventListener('keyup', _.throttle(() => {
      this.autosize(textArea);
    }, 400), false);
  }


  autosize(textArea) {
    const textCopy = textArea.getElementsByClassName('textarea-inner')[0];
    const inputTextArea = textArea.getElementsByClassName('input--textarea')[0];

    // Copy textarea contents to div browser will calculate correct height
    // of copy, which will make overall container taller, which will make
    // textarea taller.
    textCopy.innerHTML = inputTextArea.value.replace(/\n/g, '<br/>')
  }

}

export default TextArea;
